<template>
  <transition name="fade">
  <div 
    class="list"
    :class="{ 'childs-list': childs }"
  >
    <div
      class="list_item"
      v-for="item in list"
      :key="item.id"
    >   
        <div v-if="item.childs">
          <p 
            class="list_question list_question-childs"
            @click="showChilds(item.id)"
          >
            <span
              class="list_question-icon"
              :class="{ 'list_question-icon-open': isShowChilds[item.id]  }"
            >
              <i class="v-icon notranslate mdi mdi-menu-down theme--light"></i>
            </span>
            <span>
              {{ item.question }}
            </span>
          </p>

          <transition name="fade">
            <div
              class="childs"
              :class="{ 'childs-active' : isShowChilds[item.id]}"
            >
              <SupportList
                :list="item.childs"
                :childs="true"
              />
            </div>
          </transition>

        </div>

        <div v-else>
            
          <p 
            class="list_question list_question-no-childs"
            @click="entrySupportDetails(item)"
          >
            <span class="list_question-icon"></span>
            <span
              :class="{ 'list_question-active': clickedQuestion == item.id }"
            >
              {{ item.question }}
            </span>
          </p>
        </div>
    </div>
  </div>
  </transition>
</template>
<script>

import { mapGetters } from 'vuex'

export default {
  name: 'SupportList',
  props: {
    list: {
      type: [Object, Array],
      required: true
    },
    childs: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isShowChilds: []
    }
  },

  mounted () {
    this.entryValueShowChilds(this.list);
    this.entryStartSupportDetails();
  },
  computed: {
    ...mapGetters({
      clickedQuestion: 'getClickedQuestion'
    })
  },
  methods: {
    showChilds (id) {
      this.isShowChilds[id] = !this.isShowChilds[id]
      this.$forceUpdate()
    },

    entryValueShowChilds (list) {
      list.forEach(item => {
        if (item.childs) {
          this.isShowChilds[item.id] = false
          this.entryValueShowChilds(item.childs)
        }
      })
    },
    
    entryStartSupportDetails () {
      if (this.list[0]?.childs) {
        this.entrySupportDetails(this.list[0].childs[0])
      } else {
        this.entrySupportDetails(this.list[0])
      }
    },

    entrySupportDetails (details) {
      this.$store.dispatch('supportDetails', details)
    }
   }
 }
</script>
<style lang="scss" scoped>
  .list {
    max-width: 300px;
    padding-right: 10px;
    @media (max-width: 1024px) {
      width: 100%;
    }

    .childs {
      padding-left: 10px;
      max-height: 0;
      transition: max-height 0.3s ease-out;
      overflow: hidden;

      &-active {
         max-height: 500px;
         transition: max-height 0.3s ease-in;
      }

      @media (max-width: 1024px) {
        
      }
    }

    &_question {
      cursor: pointer;
      

      &-childs {
        display: flex;
        align-items: baseline;
        font-weight: 500;
      }

      &-active {
        text-decoration: underline;
      }

      &-no-childs {
        margin-left: 25px;
      }
      
      &-icon {
        display: block;
        width: 25px;
        transform: rotate(-90deg);
        transition: all 0.3s ease 0s;

        &-open {
          transform: rotate(0deg);
        }
      }
    }
  }

  .fade-enter-active {
    transition: all 0.3s ease-out;
  }

  .fade-leave-active {
    transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
  }

</style>